import { DEFAULT_HIGHLIGHTED_SYMBOL_SIZE } from "constants/chart.constants";
import { EvaChartStates } from "types/factory";

import {
  BLUR_OPACITY,
  DEFAULT_WIDTH,
  DEFAULT_Z_INDEX,
  HIGHLIGHTED_WIDTH,
  HIGHLIGHTED_Z_INDEX,
  SELECTED_WELL_COLOR,
  SELECTED_WELL_Z_INDEX
} from "../../translators/constants";
import { computeSelectionStates } from "../../translators/utils";

export function trendDateHighlightedSeries(states: Partial<EvaChartStates>) {
  const {
    series,
    hoverLegendItem,
    hoverLegendGroup,
    attentionWells,
    selectedGroups = [],
    chartOptions
  } = states;

  const chartOptionSeries = chartOptions?.series ?? [];
  const isOpaque = !(hoverLegendItem || selectedGroups.length > 0);

  return series.map((s, index) => {
    const { label, style, groupTitle } = s;

    // find corresponding series from chartOptionsSeries by comparing label with name from chartOptions
    const chartOptionSeriesItemData = Array.isArray(chartOptionSeries)
      ? chartOptionSeries.find((item) => item?.name === label)?.data
      : undefined;

    const isPoint =
      Array.isArray(chartOptionSeriesItemData) && chartOptionSeriesItemData.length === 1;

    const { isSelectedWell, isHovered } = computeSelectionStates({
      hoverLegendItem,
      hoverLegendGroup,
      attentionWells,
      label,
      groupTitle,
      selectedGroups
    });

    const id =
      groupTitle !== label
        ? `${groupTitle}, ${label}, ${index}`
        : `${groupTitle}, ${index}`;

    return {
      id,
      itemStyle: {
        color: isSelectedWell ? "#000" : style?.hexColor ?? "#000"
      },
      lineStyle: {
        width: isHovered ? HIGHLIGHTED_WIDTH : style?.thickness ?? DEFAULT_WIDTH,
        color: isSelectedWell ? SELECTED_WELL_COLOR : style?.hexColor,
        opacity: isOpaque ? 1 : isHovered ? 1 : BLUR_OPACITY
      },

      z: isSelectedWell
        ? SELECTED_WELL_Z_INDEX
        : isHovered
        ? HIGHLIGHTED_Z_INDEX
        : DEFAULT_Z_INDEX,
      ...(isPoint
        ? {
            symbolSize: isHovered ? DEFAULT_HIGHLIGHTED_SYMBOL_SIZE : 5
          }
        : {})
    };
  });
}
